import { useState } from "react"
import useLoading from "../../../components/Common/useLoading"
import InventoryReportService from "../../../api/Inventory/InventoryReportService"

/*
    Medication = 1,
    Protocol = 2,
    ProtocolMedication = 3,
*/
export default function useInventoryReportLog({ reportType = 1 }) {
    const [inventoryLog, setInventoryLog] = useState(null)
    const [isLoading, working] = useLoading();

    const filterLogs = async ({ protocolId = null, fromDate = null, toDate = null, expirationDate = null, releaseId = null, state = null, patientNumber = null, dispensedDate = null, returnDate = null, kitNumber = null, inventoryItemId = null }) => {

        const result = await InventoryReportService.GetInventoryReportLog({
            protocolId, fromDate, toDate, reportType, expirationDate, releaseId, state,
            patientNumber, dispensedDate, returnDate, kitNumber, inventoryItemId
        })

        return result.Succeeded ? result.Value : null
    }

    const navigation = {
        search: async ({ protocolId = null, fromDate = null, toDate = null, expirationDate = null, releaseId = null, state = null, patientNumber = null, dispensedDate = null, returnDate = null, kitNumber = null, inventoryItemId = null }) => await working(async () => {
            const result = await filterLogs({ protocolId, fromDate, toDate, expirationDate, releaseId, state, patientNumber, dispensedDate, returnDate, kitNumber, inventoryItemId });
            setInventoryLog(result);
        }),
        downloadExcel: async ({ protocolId = null, fromDate = null, toDate = null, expirationDate = null, releaseId = null, state = null, patientNumber = null, dispensedDate = null, returnDate = null, kitNumber = null, inventoryItemId = null }) => {
            const result = await InventoryReportService.GetInventoryReportLogExcel({
                protocolId, fromDate, toDate, reportType, expirationDate, releaseId, state,
                patientNumber, dispensedDate, returnDate, kitNumber, inventoryItemId
            })

            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            const fileName = result?.headers?.['content-disposition']?.split('filename=')[1]?.split(';')[0]?.replace(/"/g, '') || `InventoryReport_${new Date().toLocaleDateString()}.xlsx`;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        }
    }

    return [inventoryLog, isLoading, navigation]
}
